import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "h-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "bg-aph-green h-4" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressBar',
  props: {
    total: {},
    totalComplete: {}
  },
  setup(__props: any) {

const props = __props;



const segmentWidth = computed(() => {
  return ((props.totalComplete || 0) / ((props.total || 0))) * 100;
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "bg-white h-4",
        style: _normalizeStyle({ width: `${segmentWidth.value}%` })
      }, _hoisted_4, 4)
    ])
  ], 512)), [
    [_vShow, _ctx.total && _ctx.total > 0]
  ])
}
}

})